import { api_configuration } from "common";
import api_report = api_configuration.report_protocol_types;
import api_report_arguments = api_configuration.report_protocol_types.arguments_;
import api_excel_transformation = api_configuration.report_protocol_types.collection_query_to_table.alan_api;
import api_client_reply = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_reply.alan_api;
import api_client_request = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_request.alan_api;
import { client_state } from "../../state/ClientState";
import api_client_state = api_configuration.types.client_state.alan_api;
import messages = require("../../front/messages");
import { saveAs } from "./saveAs";
import createReportGenerationRequest = require("../../state 2 interface/createReportGenerationRequest");
import { addMessage } from "../../front/messages";
import { download_from_report_resource, post_to_report_resource } from "../../interface/ReportResourceProxy";
import serializeNumber = require("../../state 2 interface/serializeNumber");
import * as papa from "papaparse";
import { translate } from "../../front/translate";
import { isNonNull } from "../../validation";
import { DatastoreProxy } from "../../interface/DatastoreProxy";
import { evaluateReportValidity } from "./update";
import { createCSVBlob } from "../../utils";
import { TranslationKey, FormatString } from "../../front/translate";

const padTwo = function (number: number): string {
	const result = "" + number;
	if (result.length === 1) {
		return "0" + number;
	}
	return result;
};

export function initializedReport(
	report: api_client_state.Creport_types__node
): api_client_state.Cyes__initialized__report_types {
	return report.properties.initialized.switch({
		yes: ($) => $,
		no: () => {
			report.properties.initialized.set("yes", {
				parameters: {
					"is valid": "no",
					parameters: report.key.ref.properties.parameters.map<api_client_state.Tparameters>((parameter) => ({
						type: parameter.properties.type.switch({
							number: [
								"number",
								{
									"is set": "no",
									"is valid": "no",
									"numerical type properties": { initialized: "no" },
								},
							],
							text: [
								"text",
								{
									"is set": "no",
									"is valid": "no",
								},
							],
						}),
					})),
				},
				templates: {},
			});
			const initialized_report = report.properties.initialized.cast("yes");
			evaluateReportValidity(initialized_report.properties.parameters);
			initializeTemplates(initialized_report);
			return initialized_report;
		},
	});
}

function initializeTemplates(report: api_client_state.Cyes__initialized__report_types): void {
	//FIXME cache the downloaded templates.
	const report_request = api_report.report_protocol_request.alan_api.Creport_protocol_request.create({
		type: ["listing", {}],
		"access type": createReportGenerationRequest.determineAccessType(),
	});

	post_to_report_resource(report_request, function (reply) {
		const listing = reply.properties.type
			.cast("listing")
			.properties.reports.toArray()
			.filter((template) => template[1].properties.type === report.parent.key.entry);
		report.properties.templates.forEach((template) => {
			report.properties.templates.delete(template.key);
		});
		listing.forEach((template) => {
			report.properties.templates.create(template[0], {});
		});
	});
}

export function download_report(report: api_client_state.Cyes__initialized__report_types, template: string): void {
	report.properties.parameters.properties.is_valid.switch({
		yes: () => {
			const download_request =
				api_report.report_protocol_download_request.alan_api.Creport_protocol_download_request.create({
					"access type": createReportGenerationRequest.determineAccessType(),
					type: [
						"predefined",
						{
							report: template,
							arguments: JSON.stringify(
								api_report_arguments.serializer_json.serialize(
									api_report_arguments.alan_api.Carguments.create(
										{
											arguments: report.properties.parameters.properties.parameters.map((parameter) => ({
												type: parameter.properties.type.switch<api_report_arguments.alan_api.Targuments__["type"]>({
													number: ($) => [
														"number",
														{
															value: $.properties.is_set.cast("yes").properties.value.value,
														},
													],
													text: ($) => [
														"text",
														{
															value: $.properties.is_set.cast("yes").properties.value,
														},
													],
												}),
											})),
											"context node": reportContextNode(report.parent.parent, { "has step": "no" }),
										},
										{
											parameters: report.parent.key.ref,
										}
									)
								)
							),
						},
					],
				});
			download_from_report_resource(download_request, function (report) {
				const today = new Date();
				const timestamp =
					today.getFullYear() +
					padTwo(today.getMonth() + 1) +
					padTwo(today.getDate()) +
					"-" +
					padTwo(today.getHours()) +
					padTwo(today.getMinutes()) +
					padTwo(today.getSeconds()) +
					"-";

				saveAs(report, timestamp + template);
			});
		},
		no: () => {
			messages.addMessage("warning", "Can't download report because the parameters are invalid");
		},
	});
}

function reportContextNode(
	node: api_client_state.Cnode,
	tail: api_report_arguments.alan_api.Tplural_type_arguments
): api_report_arguments.alan_api.Tplural_type_arguments {
	const parent_node = node.output.position().output.parent();
	return node.input.position().switch({
		entity: ($) =>
			$.switch({
				root: () => tail,
				entry: ($) =>
					reportContextNode(parent_node.cast("node"), {
						"has step": [
							"yes",
							{
								key: $.properties.key.ref.properties.is_set.switch({
									yes: ($) => $.properties.text,
									no: "",
								}),
								tail: tail,
							},
						],
					}),
			}),
		group: () => reportContextNode(parent_node.cast("node"), tail),
		state: () => reportContextNode(parent_node.cast("node"), tail),
		root: () => tail,
	});
}

export function download_ad_hoc_report(query: api_client_state.Cquery__use_for__query): void {
	const report_generation_request = createReportGenerationRequest.fromQuery(query);
	download_from_report_resource(report_generation_request, function (report) {
		const today = new Date();
		const timestamp =
			today.getFullYear() +
			padTwo(today.getMonth() + 1) +
			padTwo(today.getDate()) +
			"-" +
			padTwo(today.getHours()) +
			padTwo(today.getMinutes()) +
			padTwo(today.getSeconds()) +
			"-";

		saveAs(report, timestamp + report_name_from_path(query.inferences.node_context().properties.path) + ".xlsx");
	});
}

function mapQueryResultsToCsv(
	collection_query_reply: api_client_reply.Cexists__context__collection_query,
	transformation: api_excel_transformation.Ccollection_query_to_table
) {
	const result: { [key: string]: PropertyType }[] = [];
	type PropertyType = string | null;
	function walkEntries(
		entry_result: api_client_reply.Ccollection_query_entries,
		collection_block: api_excel_transformation.Ccollection_block,
		headers: [string, string][] = []
	) {
		entry_result.properties.has_steps.switch({
			yes: function (has_steps) {
				has_steps.properties.entries.forEach(function ($) {
					const collection_name = has_steps.inferences.step().properties.collection.entry;
					walkEntries($.properties.tail, collection_block, headers.concat([[collection_name, $.key]]));
				});
			},
			no: function ($) {
				const row: Record<string, PropertyType> = {};
				const parent_headers: string[] = [];
				for (let hi = 0; hi < headers.length - 1; hi += 1) {
					const header_name = headers[hi][0];
					parent_headers.push(header_name);
					row[parent_headers.join(".")] = headers[hi][1];
				}
				mapCollectionBlocks(collection_block, function (column) {
					const node_query = $.properties.properties;
					const property_selection = column.properties.property;
					const value = getPropertyValue(node_query, property_selection);
					const csv_header = column.properties.header;
					row[csv_header] = value;
				});
				result.push(row);
			},
		});
	}

	function getPropertyValue(
		node_query: api_client_reply.Cnode_query_result,
		property_selection: api_excel_transformation.Cproperty_selection
	) {
		const property = node_query.properties.properties.get(property_selection.properties.property.ref.key)!;
		const value = property.properties.result.switch<PropertyType>({
			exists: function ($) {
				return $.properties.type.switch<PropertyType>({
					"id path": null,
					file: null,
					number: function ($) {
						return $.inferences.number().properties.expression.properties.type.switch({
							"number property": function (number_property) {
								const nummerical_type =
									number_property.properties.signed_number_property.properties.property_name.ref.properties
										.numerical_type.ref;
								return serializeNumber.serializeNumber(
									$.properties.value.value,
									serializeNumber.getStaticDecimalsFromNumericalType(nummerical_type),
									nummerical_type,
									"english"
								);
							},
							count: () => String($.properties.value.value),
							division: () => String($.properties.value.value),
							maximum: () => String($.properties.value.value),
							minimum: () => String($.properties.value.value),
							product: () => String($.properties.value.value),
							remainder: () => String($.properties.value.value),
							"state based": () => String($.properties.value.value),
							sum: () => String($.properties.value.value),
							"sum list": () => String($.properties.value.value),
							value: () => String($.properties.value.value),
						});
					},
					"state group": function ($) {
						return $.properties.state.ref.key;
					},
					text: function ($) {
						return $.properties.value;
					},
					collection: ($) => {
						const value: string[] = [];
						const join_selection = property_selection.properties.type.cast("join");
						for (const entry of $.properties.entries) {
							const entry_value = getPropertyValue(entry[1].properties.properties, join_selection.properties.value);
							if (entry_value !== null) {
								value.push(entry_value);
							}
						}
						return value.join(join_selection.properties.separator);
					},
				});
			},
			"does not exist": null,
			"permission denied": null,
		});
		return value;
	}

	function mapCollectionBlocks(
		collection_block: api_excel_transformation.Ccollection_block,
		callback: (column: api_excel_transformation.Cyes__has_columns__collection_block) => void
	) {
		collection_block.properties.has_columns.switch({
			no: undefined,
			yes: function ($) {
				callback($);
				mapCollectionBlocks($.properties.next, callback);
			},
		});
	}

	function createHeaderFields(collection_path: api_client_request.Ccollection_query_path): string[] {
		return collection_path.properties.has_steps.switch<string[]>({
			no: [],
			yes: ($) => [$.properties.collection.entry].concat(createHeaderFields($.properties.tail)),
		});
	}
	function createFields(column: api_excel_transformation.Ccollection_block): string[] {
		return column.properties.has_columns.switch<string[]>({
			no: [],
			yes: ($) => [$.properties.header].concat(createFields($.properties.next)),
		});
	}
	let fields = createHeaderFields(collection_query_reply.parent.inferences.source().properties.collection_path).map(
		(_, index, headers) => headers.slice(0, index + 1).join(".")
	);
	transformation.properties.type.switch({
		"collection query": function ($) {
			fields = fields
				.concat(createFields($.properties.columns))
				.filter((value, index, self) => self.indexOf(value) === index); // only unique fields
			collection_query_reply.properties.entries.switch({
				no: undefined,
				yes: (has_entries) => {
					walkEntries(has_entries.properties.entries, $.properties.columns);
				},
			});
		},
		"acyclic graph list query": undefined, // FIXME: implement graph queries
	});
	return papa.unparse({ data: result, fields: fields });
}

export function download_ad_hoc_import_template(query: api_client_state.Cquery__use_for__query): void {
	const import_template = createReportGenerationRequest.forImportTemplate(query);
	const client_request = import_template.query;
	const transformation = import_template.transformation;
	const report_name = report_name_from_path(query.inferences.node_context().properties.path);
	DatastoreProxy.instance.collectionQuery(client_request, {
		handleSuccess: function (
			result: api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_reply.alan_api.Ccollection_query
		) {
			result.properties.context.switch({
				exists: function ($) {
					saveAs(createCSVBlob(mapQueryResultsToCsv($, transformation)), report_name + ".csv");
				},
				"does not exist": function () {
					messages.addMessage(
						"warning",
						{ phrase: "Could not download report {0}", vars: [report_name] },
						{ body: "Reopen the view and try again." }
					);
				},
				"permission denied": function () {
					messages.addMessage(
						"warning",
						{ phrase: "Could not download report {0}", vars: [report_name] },
						{ body: "Permission denied." }
					);
				},
			});
		},
		handleFailure: function () {
			messages.addMessage("warning", { phrase: "Could not download report {0}", vars: [report_name] });
		},
	});
}

export function report_name_from_path(
	path: api_configuration.libraries.gui_definition_lib.types.views.alan_api.Cquery_path,
	separator = ""
): string {
	return path.properties.has_steps.switch({
		no: "",
		yes: ($) => separator + $.properties.collection.entry + report_name_from_path($.properties.tail, "."),
	});
}

export function upload_template(
	report_type: api_client_state.Creport_types__client_state,
	file_event: File,
	root_node: api_client_state.Cnode
): void {
	const report_name = file_event.name;
	function reinitializeRootReportTemplates() {
		if (root_node.properties.report_types.has(report_type.key.entry)) {
			const report = root_node.properties.report_types.get(report_type.key.entry)!;
			switch (report.properties.initialized.state.name) {
				case "no":
					break;
				case "yes": {
					const $ = report.properties.initialized.state.node;
					initializeTemplates($);
					break;
				}
				default:
					unexpectedState(report.properties.initialized.state);
			}
		}
	}
	function doUpload() {
		const reader = new FileReader();
		reader.readAsDataURL(file_event);
		reader.onload = function () {
			const report_request = api_report.report_protocol_request.alan_api.Creport_protocol_request.create({
				type: [
					"upload",
					{
						type: report_type.key.entry,
						name: report_name,
						template: isNonNull(reader.result as string).split("base64,")[1],
					},
				],
				"access type": createReportGenerationRequest.determineAccessType(),
			});
			post_to_report_resource(report_request, function (response) {
				response.properties.type.cast("upload").properties.status.switch({
					failure: function ($) {
						const message_body = $.properties.cause.switch<TranslationKey | FormatString>({
							"duplicate name": { phrase: "The file '{0}' already exists.", vars: [file_event.name] },
							"invalid name": { phrase: "The file name '{0}' is invalid.", vars: [file_event.name] },
							"server error": "Something went wrong. Please try again.",
							"unknown type": (): TranslationKey => {
								list_reports();
								return "Something went wrong. Please try again.";
							},
						});
						addMessage("warning", "Cannot upload template", { body: message_body });
					},
					success: function () {
						list_reports();
						reinitializeRootReportTemplates();
					},
				});
			});
		};
		reader.onerror = function () {
			messages.addMessage("error", "Cannot read template", { body: "Upload the file again." });
		};
	}
	report_type.parent.properties.reports.switchOnEntryExists(
		report_name,
		function ($) {
			if (confirm(translate({ phrase: 'Replace "{0}"?', vars: [report_name] }))) {
				delete_template($, root_node, function () {
					doUpload();
				});
			} else {
				list_reports();
			}
		},
		function () {
			doUpload();
		}
	);
}

export function delete_template(
	template: api_client_state.Creports,
	root_node: api_client_state.Cnode,
	callback?: () => void
): void {
	const report_request = api_report.report_protocol_request.alan_api.Creport_protocol_request.create({
		type: [
			"delete",
			{
				report: template.key,
			},
		],
		"access type": createReportGenerationRequest.determineAccessType(),
	});
	post_to_report_resource(report_request, function () {
		callback?.();
		list_reports();
		template.properties.definition.switch({
			known: ($) => {
				const report_type = root_node.properties.report_types.get($.properties.of_type.entry);
				report_type?.properties.initialized.switch({
					no: undefined,
					yes: ($) => {
						$.properties.templates.delete(template.key);
					},
				});
			},
			unknown: undefined,
		});
	});
}

export function list_reports(): void {
	const report_request = api_report.report_protocol_request.alan_api.Creport_protocol_request.create({
		type: ["listing", {}],
		"access type": createReportGenerationRequest.determineAccessType(),
	});

	post_to_report_resource(report_request, function (reply) {
		const listing = reply.properties.type.cast("listing");
		client_state.properties.reports.forEach(function (report) {
			client_state.properties.reports.delete(report.key);
		});
		listing.properties.reports.forEach(function ($) {
			client_state.properties.reports.create($.key, {
				definition: client_state.properties.report_types.switchOnEntryExists<api_client_state.Treports["definition"]>(
					$.properties.type,
					(report_type) => [
						"known",
						{
							"of type": report_type.key.entry,
						},
					],
					() => "unknown"
				),
				permissions: $.properties.permissions.switch<api_client_state.Treports["permissions"]>({
					"read only": ["read only", {}],
					writable: ["writable", {}],
				}),
			});
		});
	});
}
